/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_InsteadInputs */

const en_signin_link_instead = /** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email me a sign-in link instead`)
};

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const ar_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const he_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const ur_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const es_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const fr_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const de_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const pt_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const hi_signin_link_instead = en_signin_link_instead;

/** @type {(inputs: Signin_Link_InsteadInputs) => LocalizedString} */
const bn_signin_link_instead = en_signin_link_instead;

/**
* | output |
* | --- |
* | "Email me a sign-in link instead" |
*
* @param {Signin_Link_InsteadInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_link_instead = /** @type {((inputs?: Signin_Link_InsteadInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_InsteadInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_link_instead(inputs)
	if (locale === "he") return he_signin_link_instead(inputs)
	if (locale === "ur") return ur_signin_link_instead(inputs)
	if (locale === "es") return es_signin_link_instead(inputs)
	if (locale === "fr") return fr_signin_link_instead(inputs)
	if (locale === "de") return de_signin_link_instead(inputs)
	if (locale === "pt") return pt_signin_link_instead(inputs)
	if (locale === "hi") return hi_signin_link_instead(inputs)
	if (locale === "bn") return bn_signin_link_instead(inputs)
	return /** @type {LocalizedString} */ ("Email me a sign-in link instead")
});